export const mkHeaders = (pairs) => {
  const headers = {};
  for (const pair of pairs) {
    headers[pair.value0] = pair.value1;
  }
  return headers;
};

export const requestInitJson = (method) => (headers) => (body) => ({
  method,
  headers,
  credentials: "include",
  body: JSON.stringify(body),
});

export const requestInitNoBody = (method) => (headers) => ({
  method,
  headers,
  credentials: "include",
});

export const requestInitFormData = (method) => (headers) => (formData) => ({
  method,
  headers,
  credentials: "include",
  body: formData,
});

export const fetch_ = (url) => (init) => fetch(url, init);

export const responseOk = (response) => response.ok;

export const responseStatus = (response) => response.status;

export const responseJson = (response) => response.json();

export const responseBlob = (response) => response.blob();

export const responseText = (response) => response.text();

export const newFormData = () => new FormData();

export const appendFormData = (formData) => (key) => (value) => (maybeFileName) => {
  if (maybeFileName?.value0 !== undefined) {
    formData.append(key, value, maybeFileName.value0);
  } else {
    formData.append(key, value);
  }
  return formData;
};
